import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableRow, TableBody, TableRowColumn, RaisedButton,
  CircularProgress,
} from "material-ui";
import {
  IniciarValidacionesReplicacionSolicitud, MostrarValidacionesReplicar,
  GuardarSolicitudParametrizada,
} from "./actions";
import styles from "../../styles/styles";
import urlHelper from "../../../helpers/urlHelper";

class ReplicarSolicitud extends React.Component {
  componentWillMount() {
  }

  ReplicarSolicitud = () => {
    this.props.dispatch(MostrarValidacionesReplicar(true));
    this.props.dispatch(IniciarValidacionesReplicacionSolicitud());
  }

  AplicarReplicarSolicitud = () => {
    this.props.dispatch(MostrarValidacionesReplicar(false));
    this.props.dispatch(GuardarSolicitudParametrizada());
  }

  ModalSolicitudReajuste = () => {
    urlHelper.RedirectTo("SolicitudesRealizadas");
  }

  BColorSegunValidacion = (validacion) => {
    if (validacion === true) {
      return "#dcf7dc";
    }
    if (validacion === false) {
      return "#f7dcdd";
    }
    return "";
  }

  IconSegunValidacion = (validacion) => {
    if (validacion === true) {
      return <i className="material-icons">done</i>;
    }
    if (validacion === false) {
      return <i className="material-icons">clear</i>;
    }
    return <CircularProgress size={25} />;
  }

  render() {
    const centrosAtencionNoEncontrados = [];
    this.props.detalleValidacionCentrosAtencion
      .filter((c) => c.valido === false)
      .forEach((c) => {
        const cc = this.props.centrosAtencion.filter((ca) => ca.Secuencia === c.secuencia);
        if (cc && cc.length > 0) {
          centrosAtencionNoEncontrados.push(cc[0].Descripcion);
        }
      });

    const lvsc = this.props.loadingValidacionSolicitudEnCurso;
    const lvca = this.props.loadingValidacionCentrosAtencion;
    const lvih = this.props.loadingValidacionIdsHomologos;
    const lviha = this.props.loadingValidacionIdsHomologosAux;

    return (
      <div>
        {this.props.modalSolicitudReplicada ?
          null
          :
          <div style={styles.h3}>
            ¿Desea replicar la solicitud en isapre&nbsp;
            <strong>{this.props.isapre === "B" ? "VidaTres" : "Banmedica"}</strong>?
            <RaisedButton
              label="Replicar Solicitud"
              onClick={this.ReplicarSolicitud}
              secondary
              labelStyle={{ fontSize: "11px" }}
              overlayStyle={{ borderRadius: 5 }}
              rippleStyle={{ borderRadius: 5 }}
              style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
              buttonStyle={{ borderRadius: 5 }}
              disabled={!this.props.usuarioPuedeReplicar}
            />
            {!this.props.usuarioPuedeReplicar ?
              <p style={{ color: "#a80000" }}>
                Permisos insuficientes para replicar solicitud. Contacte a su administrador.
              </p>
              : null}
          </div>
        }
        {this.props.modalValidacion ?
          <div style={{ marginTop: 10 }}>
            <Table
              selectable={false}
              multiSelectable={false}
              style={{ width: 800, margin: "auto" }}
            >
              <TableBody displayRowCheckbox={false}>

                <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvca) }}>
                  <TableRowColumn>Validación Centros Atención replicados</TableRowColumn>
                  <TableRowColumn style={{ width: 50, padding: 0 }}>
                    {this.IconSegunValidacion(lvca)}
                  </TableRowColumn>
                  <TableRowColumn style={{ whiteSpace: "normal" }}>
                    {lvca === false ?
                      <span>
                        No se encontraron los centros de atención a replicar en :&nbsp;
                        <strong>{centrosAtencionNoEncontrados.join(", ")}</strong><br></br>
                        Favor comunicarse con Convenios Médicos.
                      </span>
                      : null}
                  </TableRowColumn>
                </TableRow>

                {centrosAtencionNoEncontrados.length === 0 ?
                  <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvsc) }}>
                    <TableRowColumn>Validación solicitud en curso</TableRowColumn>
                    <TableRowColumn style={{ width: 50, padding: 0 }}>
                      {this.IconSegunValidacion(lvsc)}
                    </TableRowColumn>
                    <TableRowColumn style={{ whiteSpace: "normal" }}>
                      {lvsc === false ?
                        <span>
                          Ya posee una solicitud, con al menos una prestacion en curso, en la isapre a replicar.
                        </span>
                        : null}
                      {lvsc === true ?
                        <span>No posee solicitudes en curso en la isapre a replicar.</span>
                        : null}
                    </TableRowColumn>
                  </TableRow>
                  : null}


                {lviha === false ?
                  <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvih) }}>
                    <TableRowColumn>Validación prestaciones homologas</TableRowColumn>
                    <TableRowColumn style={{ width: 50, padding: 0 }}>
                      {this.IconSegunValidacion(lvih)}
                    </TableRowColumn>
                    <TableRowColumn style={{ whiteSpace: "normal" }}>
                      {lviha === false ?
                        <span>
                          No existen todas las prestaciones en la isapre a replicar
                        </span>
                        : null}
                    </TableRowColumn>
                  </TableRow>
                  : null}

              </TableBody>
            </Table>
            <div className="row justify-content-end" style={{ paddingTop: 10 }}>
              <div className="col-3">
                <RaisedButton
                  label="Aplicar replicación"
                  onClick={this.AplicarReplicarSolicitud}
                  secondary
                  labelStyle={{ fontSize: "11px" }}
                  overlayStyle={{ borderRadius: 5 }}
                  rippleStyle={{ borderRadius: 5 }}
                  style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                  buttonStyle={{ borderRadius: 5 }}
                  disabled={!(lvsc === true && lvca === true && lviha === true)}
                />
              </div>
            </div>
          </div>
          : null}

        {this.props.modalSolicitudReplicada ?
          <div>
            <div className="col-12" style={{ margin: 0, padding: 0 }}>
              <div style={styles.h1}>
                Solicitud de Actualización Arancel / Replicación a isapre&nbsp;
                <strong>{this.props.isapre === "B" ? "VidaTres" : "Banmedica"}</strong>
              </div>
            </div>
            {this.props.loadingDetalleSolicitud === 0 ?
              <div>
                <div className="col-5" style={{ margin: 0, padding: 0 }}>
                  <div className="row">
                    <div className="col-4" style={styles.tituloEnviarSolicitud}>
                      N°  solicitud
                    </div>
                    <div className="col-4" style={styles.datoEnviarSolicitud}>
                      {this.props.idSolicitudReplicada}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4" style={styles.tituloEnviarSolicitud}>
                      {(this.props.idSolHomologa == null) ? null : 'N°  solicitud Homologador'}
                    </div>
                    <div className="col-4" style={styles.datoEnviarSolicitud}>
                      {(this.props.idSolHomologa == null) ? null : this.props.idSolHomologa}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4" style={styles.tituloEnviarSolicitud}>
                      Fecha Solicitud
                    </div>
                    <div className="col-4" style={styles.datoEnviarSolicitud}>
                      {(new Date()).toLocaleDateString()}
                    </div>
                  </div>
                </div>
                <div className="col-5" style={{ margin: 0, padding: 0 }}>
                  <div className="row">
                    <div className="col-4" style={styles.tituloEnviarSolicitud}>
                      Tipo Solicitud
                    </div>
                    <div className="col-4" style={styles.datoEnviarSolicitud}>
                      Actualizar Arancel
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4" style={styles.tituloEnviarSolicitud}>
                      Estado Solicitud
                    </div>
                    <div className="col-4" style={styles.datoEnviarSolicitud}>
                      Solicitud Enviada
                    </div>
                  </div>
                </div>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h3}>
                    La resolución de su solicitud será notificada vía electrónica a su email
                    de contacto. De igual forma podrá revisar lo solicitado y el estado de
                    su solicitud en el menú
                    <RaisedButton
                      label="Solicitudes Realizadas"
                      onClick={this.ModalSolicitudReajuste}
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  </div>
                </div>
              </div>
              :
              <CircularProgress />
            }
          </div>
          : null}
      </div>
    );
  }
}

ReplicarSolicitud.defaultProps = {
  loadingValidacionSolicitudEnCurso: null,
  loadingValidacionCentrosAtencion: null,
  loadingValidacionIdsHomologos: null,
  loadingValidacionIdsHomologosAux: null,
  idSolHomologa: null,
};

ReplicarSolicitud.propTypes = {
  isapre: PropTypes.string.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  usuarioPuedeReplicar: PropTypes.bool.isRequired,
  modalValidacion: PropTypes.bool.isRequired,
  loadingValidacionSolicitudEnCurso: PropTypes.bool,
  loadingValidacionCentrosAtencion: PropTypes.bool,
  loadingValidacionIdsHomologos: PropTypes.bool,
  loadingValidacionIdsHomologosAux: PropTypes.bool,

  detalleValidacionCentrosAtencion: PropTypes.array.isRequired,
  idsPrestacionesHomologas: PropTypes.array.isRequired,
  loadingDetalleSolicitud: PropTypes.number.isRequired,
  modalSolicitudReplicada: PropTypes.bool.isRequired,
  idSolicitudReplicada: PropTypes.number.isRequired,

  idSolHomologa: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  isapre: state.global.isapre,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  dialogGeneric: state.global.dialogGeneric,
  usuarioPuedeReplicar: state.replicarSolicitud.usuarioPuedeReplicar,
  modalValidacion: state.replicarSolicitud.modalValidacion,
  loadingValidacionSolicitudEnCurso: state.replicarSolicitud.loadingValidacionSolicitudEnCurso,
  loadingValidacionCentrosAtencion: state.replicarSolicitud.loadingValidacionCentrosAtencion,
  loadingValidacionIdsHomologos: state.replicarSolicitud.loadingValidacionIdsHomologos,
  loadingValidacionIdsHomologosAux: state.replicarSolicitud.loadingValidacionIdsHomologosAux,

  detalleValidacionCentrosAtencion: state.replicarSolicitud.detalleValidacionCentrosAtencion,
  idsPrestacionesHomologas: state.replicarSolicitud.idsPrestacionesHomologas,

  loadingDetalleSolicitud: state.replicarSolicitud.loadingDetalleSolicitud,
  modalSolicitudReplicada: state.replicarSolicitud.modalSolicitudReplicada,
  idSolicitudReplicada: state.replicarSolicitud.idSolicitudReplicada,

  idSolHomologa: state.grillaSolicitud.IdSolicitudHomologador,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReplicarSolicitud);
